import { ActionIcons, useInputIcons } from "PFComponents/action_icons";
import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import { Label } from "PFComponents/label";
import { TooltipIcon } from "PFComponents/tooltip";
import { useTranslation } from "react-i18next";

type MatchAttributeFieldHeaderProps = {
  label: string;
  required: boolean;
  locked: boolean;
  onAdd: VoidFunction;
  onClear?: VoidFunction;
  onRestore?: VoidFunction;
  addDisabled?: boolean;
  actionsDisabled?: boolean;
};

export const MatchAttributeFieldHeader = ({
  label,
  required,
  locked,
  onAdd,
  onClear,
  onRestore,
  addDisabled,
  actionsDisabled
}: MatchAttributeFieldHeaderProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections.matchAttributes" });
  const { t: tTranslation } = useTranslation();
  const actionIcons = useInputIcons({
    onRestore,
    onClear,
    disabled: actionsDisabled,
    label,
    locked
  });

  return (
    <Inline alignItems="center" spread>
      <Inline alignItems="center">
        <Label text={label} required={required} variant="bodyBold" />
      </Inline>
      <Inline alignItems="center">
        {locked ? (
          <TooltipIcon
            iconName="locked"
            iconProps={{ size: "sm" }}
            content={tTranslation("customValues.tips.noPermissionsTip")}
          />
        ) : (
          <>
            <ActionIcons actionIcons={actionIcons} />
            <Button text={t("add")} kind="text" onClick={onAdd} disabled={addDisabled} />
          </>
        )}
      </Inline>
    </Inline>
  );
};
